
import { Link } from 'react-router-dom';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#0B0B0B', borderTop: '1px solid rgba(242,237,227,0.08)', padding: '4rem 0 2rem' }}>
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <p style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: '1.2rem', letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#F2EDE3', marginBottom: '1rem' }}>
              Johnny Vaz
            </p>
            <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: '0.85rem', lineHeight: 1.65, color: '#8C8377', marginBottom: '1.5rem' }}>
              Palestrante de IA aplicada e formação de pessoas. Fundador da Geniaria e autor do livro PPA.
            </p>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <a href="https://github.com/johnnyvaz" target="_blank" rel="noopener noreferrer" aria-label="GitHub" style={{ color: '#8C8377' }} className="hover:text-white transition-colors">
                <Github size={18} />
              </a>
              <a href="https://www.linkedin.com/in/johnnyvaz/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={{ color: '#8C8377' }} className="hover:text-white transition-colors">
                <Linkedin size={18} />
              </a>
              <a href="mailto:contato@johnnyvaz.com.br" aria-label="Email" style={{ color: '#8C8377' }} className="hover:text-white transition-colors">
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1rem' }}>
              Links
            </p>
            <ul style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem', listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                { label: 'Início', to: '/' },
                { label: 'Palestras', to: '/palestras' },
                { label: 'Sobre', to: '/about' },
                { label: 'Projetos', to: '/projects' },
                { label: 'Mentoria', to: '/mentoria' },
                { label: 'Imprensa', to: '/imprensa' },
                { label: 'Blog', to: '/blog' },
                { label: 'Contato', to: '/contact' },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: '0.85rem', color: '#8C8377', textDecoration: 'none' }}
                    className="hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1rem' }}>
              Contato
            </p>
            <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: '0.8rem', lineHeight: 1.65, color: '#8C8377', marginBottom: '0.5rem' }}>
              Avenida Paulista, 1106, Sala 01, Andar 16<br />
              São Paulo/SP, CEP: 01310-914
            </p>
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.65rem', letterSpacing: '0.06em', color: '#8C8377', marginBottom: '1.25rem' }}>
              CNPJ: 63.548.781/0001-73
            </p>
            <Link
              to="/contact"
              style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.65rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#FF4500', textDecoration: 'none' }}
            >
              Entre em contato →
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div style={{ borderTop: '1px solid rgba(242,237,227,0.08)', paddingTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C8377' }}>
              © {currentYear} Johnny Vaz · JOHNNY VAZ IA SOLUTIONS LTDA
            </p>
            <div style={{ display: 'flex', gap: '1.5rem' }}>
              <Link to="/politica-privacidade" style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: '#8C8377', textDecoration: 'none' }} className="hover:text-white transition-colors">
                Privacidade
              </Link>
              <Link to="/pix" style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: '#FF4500', textDecoration: 'none' }}>
                Pix
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
